import { Typography } from "@material-tailwind/react";

const NavList = (
  <ul className="mt-2 mb-4 flex flex-col gap-2 lg:mb-0 lg:mt-0 lg:flex-row lg:items-center lg:gap-6">
    <Typography
      as="li"
      variant="small"
      color="black"
      className="p-1 font-normal"
    >
      <a href="#home" className="flex items-center text-base lg:text-lg font-medium lg:hover:text-gray-600">
        Home
      </a>
    </Typography>
    <Typography
      as="li"
      variant="small"
      color="black"
      className="p-1 font-normal"
    >
      <a href="#service" className="flex items-center text-base lg:text-lg font-medium lg:hover:text-gray-600">
        Services
      </a>
    </Typography>
    <Typography
      as="li"
      variant="small"
      color="black"
      className="p-1 font-normal"
    >
      <a href="#value" className="flex items-center text-base lg:text-lg font-medium lg:hover:text-gray-600">
        Our Value
      </a>
    </Typography>
    <Typography
      as="li"
      variant="small"
      color="black"
      className="p-1 font-normal"
    >
      <a href="#team" className="flex items-center text-base lg:text-lg font-medium lg:hover:text-gray-600">
        Our Team
      </a>
    </Typography>
    <Typography
      as="li"
      variant="small"
      color="black"
      className="p-1 font-normal"
    >
      <a href="#about" className="flex items-center text-base lg:text-lg font-medium lg:hover:text-gray-600">
        About Us
      </a>
    </Typography>

  </ul>
);

export default NavList;